
import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/fea224636beb08bfeb8a0ff966acd6a7.jpg"
          alt="Daliah Secret luxury collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center px-6">
        <h2 className="text-4xl font-serif text-white mb-4 leading-snug">
          Experience the Daliah Secret Difference
        </h2>
        <p className="text-white/80 text-[15px] leading-relaxed mb-10 max-w-xl mx-auto">
          Explore our curated collection of handcrafted perfumes and nourishing hair oils. 
          Each product is a testament to our unwavering commitment to quality and nature.
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#2E7D32] text-white font-medium hover:bg-[#1B5E20] transition-all cursor-pointer whitespace-nowrap text-sm tracking-wide"
          >
            SHOP NOW
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/50 text-white font-medium hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-sm tracking-wide"
          >
            READ OUR BLOG
          </Link>
        </div>
      </div>
    </section>
  );
}
